<template>
  <div id="collectionPoolModal" class="content">
    <modal :show.sync="shouldShow" @hidden="onClickCancel" v-on:close="onClickCancel" footerClasses="justify-content-center" type="notice">
      <h4 slot="header" class="modal-title">
        <b>스코어 가중치 설정</b>
      </h4>
      <div class="row">
        <div class="col-sm-3">
          <h4 class="card-title text-left">좋아요수</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <base-input placeholder="가중치" v-model="likeCount">
                <span slot="helpBlock" class="form-text"></span>
              </base-input>
            </div>
          </div>
        </div>
        <div class="col-sm-3">
          <h4 class="card-title text-left">좋아요 증감량</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <base-input placeholder="가중치" v-model="likeCountVelocity">
                <span slot="helpBlock" class="form-text"></span>
              </base-input>
            </div>
          </div>
        </div>
        <div class="col-sm-3">
          <h4 class="card-title text-left">댓글수</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <base-input placeholder="가중치" v-model="commentCount">
                <span slot="helpBlock" class="form-text"></span>
              </base-input>
            </div>
          </div>
        </div>
        <div class="col-sm-3">
          <h4 class="card-title text-left">댓글 증감량</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <base-input placeholder="가중치" v-model="commentCountVelocity">
                <span slot="helpBlock" class="form-text"></span>
              </base-input>
            </div>
          </div>
        </div>
        <div class="col-sm-3">
          <h4 class="card-title text-left">뷰 수</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <base-input placeholder="가중치" v-model="viewCount">
                <span slot="helpBlock" class="form-text"></span>
              </base-input>
            </div>
          </div>
        </div>
        <div class="col-sm-3">
          <h4 class="card-title text-left">뷰 증감량</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <base-input placeholder="가중치" v-model="viewCountVelocity">
                <span slot="helpBlock" class="form-text"></span>
              </base-input>
            </div>
          </div>
        </div>
        <div class="col-sm-3">
          <h4 class="card-title text-left">핀 수</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <base-input placeholder="가중치" v-model="pinCount">
                <span slot="helpBlock" class="form-text"></span>
              </base-input>
            </div>
          </div>
        </div>
        <div class="col-sm-3">
          <h4 class="card-title text-left">핀 증감량</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <base-input placeholder="가중치" v-model="pinCountVelocity">
                <span slot="helpBlock" class="form-text"></span>
              </base-input>
            </div>
          </div>
        </div>
        <div class="col-sm-3">
          <h4 class="card-title text-left">공유 수</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <base-input placeholder="가중치" v-model="shareCount">
                <span slot="helpBlock" class="form-text"></span>
              </base-input>
            </div>
          </div>
        </div>
        <div class="col-sm-3">
          <h4 class="card-title text-left">공유 증감량</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <base-input placeholder="가중치" v-model="shareCountVelocity">
                <span slot="helpBlock" class="form-text"></span>
              </base-input>
            </div>
          </div>
        </div>
        <div class="col-sm-3">
          <h4 class="card-title text-left">신선도</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <base-input placeholder="가중치" v-model="freshness">
                <span slot="helpBlock" class="form-text"></span>
              </base-input>
            </div>
          </div>
        </div>
      </div>

      <div slot="footer" class="justify-content-center">
        <base-button class="footer-buttons col-6" type="success" round @click.native="onClickConfirm">저장</base-button>
        <base-button class="footer-buttons col-6" type="success" round @click.native="onClickBatch">배치</base-button>
        <base-button class="footer-buttons col-6" type="danger" round @click.native="onClickCancel">취소</base-button>
      </div>
    </modal>
  </div>
</template>
<script>
import { Modal, BaseInput } from "@/components/index";
import BaseButton from "@/components/BaseButton";

export default {
  name: "CollectionPoolModal",
  components: {
    BaseButton,
    BaseInput,
    Modal,
  },
  async created() {
    await this.getCollectionWeights();
  },
  data() {
    return {
      likeCount: 0,
      likeCountVelocity: 0,
      commentCount: 0,
      commentCountVelocity: 0,
      viewCount: 0,
      viewCountVelocity: 0,
      pinCount: 0,
      pinCountVelocity: 0,
      shareCount: 0,
      shareCountVelocity: 0,
      freshness: 0,
      scoreBatchUrl: `${window.Endpoints.blipApiServerUrl}/batches/collections/score`,
    };
  },
  props: {
    shouldShow: {
      type: Boolean,
      required: true,
    },
    onConfirm: {
      type: Function,
      required: true,
    },
    onCancel: {
      type: Function,
      required: true,
    },
  },
  methods: {
    async getCollectionWeights() {
      return this.$axios.get(`/collection/getCollectionWeights`).then((res) => {
        const data = res.data.data.data;
        this.likeCount = data.likeCount;
        this.likeCountVelocity = data.likeCountVelocity;
        this.commentCount = data.commentCount;
        this.commentCountVelocity = data.commentCountVelocity;
        this.viewCount = data.viewCount;
        this.viewCountVelocity = data.viewCountVelocity;
        this.pinCount = data.pinCount;
        this.pinCountVelocity = data.pinCountVelocity;
        this.shareCount = data.shareCount;
        this.shareCountVelocity = data.shareCountVelocity;
        this.freshness = data.freshness;
      });
    },
    onClickConfirm: async function () {
      await this.onConfirm();
      const total =
        Number(this.likeCount) +
        Number(this.likeCountVelocity) +
        Number(this.commentCount) +
        Number(this.commentCountVelocity) +
        Number(this.viewCount) +
        Number(this.viewCountVelocity) +
        Number(this.pinCount) +
        Number(this.pinCountVelocity) +
        Number(this.shareCount) +
        Number(this.shareCountVelocity) +
        Number(this.freshness);
      console.log(total);
      if (total !== 1) {
        Toast.error("가중치의 총합은 1이 되어야 합니다");
        return;
      }

      const param = {
        likeCount: this.likeCount,
        likeCountVelocity: this.likeCountVelocity,
        commentCount: this.commentCount,
        commentCountVelocity: this.commentCountVelocity,
        viewCount: this.viewCount,
        viewCountVelocity: this.viewCountVelocity,
        pinCount: this.pinCount,
        pinCountVelocity: this.pinCountVelocity,
        shareCount: this.shareCount,
        shareCountVelocity: this.shareCountVelocity,
        freshness: this.freshness,
      };

      return this.$axios.post(`/collection/setCollectionWeights`, param).then((res) => {
        window.Toast.success("설정되었습니다");
        this.onClickCancel();
      });
    },
    async onClickBatch() {
      return this.$axios.put(this.scoreBatchUrl).then((res) => {
        window.Toast.success("배치가 돕니다");
      });
    },
    onClickCancel: async function () {
      await this.onCancel();
    },
  },
};
</script>
<style lang="scss">
#collectionPoolModal .modal-dialog {
  max-width: 1200px !important;
}

.member-select {
  margin-bottom: 30px;
}

.footer {
  .footer-buttons {
    width: 100px;
  }
}
</style>
